import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    computed,
    inject,
    Input,
    OnInit,
    signal,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { BrandPicto } from '@ecm/material';
import { PortfolioFlagsService } from '@ecm/portfolio';
import { LinkSyncPipe } from '@ecm/router';

import { CarrouselItemViewModel } from '../../business/model/carrousel-item.view-model';
import { CarrouselNavigationItemViewModel } from '../../business/model/carrousel-navigation-item.view-model';
import { CarrouselOfferItemViewModel } from '../../business/model/carrousel-offer-item.view-model';
import { CarrouselStoreService } from '../../store/carrousel-store.service';

@Component({
    selector: 'ecm-carrousel-nav',
    templateUrl: 'carrousel-nav-accordion.component.html',
    styleUrls: ['carrousel-nav-accordion.component.css'],
    standalone: true,
    imports: [CommonModule, NgbModule, TranslateModule, LinkSyncPipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarrouselNavAccordionComponent implements OnInit {
    @Input() public item: CarrouselOfferItemViewModel;
    @Input() public index: string | number;
    @Input() public carrouselItem: CarrouselItemViewModel;
    @Input() public selectedLink: string;
    @Input() public carrouselLinksItemsSelected: boolean;

    private readonly router = inject(Router);
    protected readonly route = inject(ActivatedRoute);
    private readonly carrouselStore = inject(CarrouselStoreService);
    private readonly portfolioFlagsService = inject(PortfolioFlagsService);
    private readonly cdr = inject(ChangeDetectorRef);

    public e2e = 'e2e-carrousel-nav-';
    public selectedUsageCode = signal<string | null>(null);

    public getIcon = computed(() => {
        const isSosh = this.portfolioFlagsService.isSosh();
        if (this.item.brand === 'Orange' && isSosh) {
            return BrandPicto.ORANGE;
        }
        if (this.item.brand === 'Sosh' && !isSosh) {
            return BrandPicto.SOSH;
        }
    });

    public encodedCurrentItemId: string;
    public reverseBrandLogoUrl: string;

    public ngOnInit() {
        this.setSelectedNavItem();
        this.encodedCurrentItemId = btoa(this.item.cid);
    }

    public select(cid: string) {
        if (cid) {
            this.carrouselStore.selectItem(cid);
            // 🔥 Force change detection check after signal mutations (brand change)
            // Prevents ExpressionChangedAfterCheckError when brand flags update
            this.cdr.markForCheck();
        }
        this.carrouselItem.button.navigationExtras.queryParams.carrousel = this.encodedCurrentItemId;
        this.carrouselItem.button.params.set('carrousel', this.encodedCurrentItemId);
        this.carrouselStore.openLink(this.carrouselItem.button);
    }

    public openLink(navItem: CarrouselNavigationItemViewModel) {
        if (['MULTISIMI', 'MULTISIMIA'].includes(this.selectedLink.toUpperCase())) {
            this.selectedUsageCode.set(navItem.usageCode);
        }
        this.carrouselStore.openLink(navItem.button);
    }

    //Simple (but ugly) solution to know wich multisim of the same type is selected
    private setSelectedNavItem() {
        if (['MULTISIMI', 'MULTISIMIA'].includes(this.selectedLink.toUpperCase())) {
            const urlChunks = this.router.url.split('/');
            const usageCodeIdx = urlChunks.findIndex((chunk) => chunk === 'multi-sim') - 1;
            this.selectedUsageCode.set(urlChunks[usageCodeIdx]);
        }
    }
}
